export default "__VITE_ASSET__DBWjHXS3__"